"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundUploaded = backgroundUploaded;
exports.backgroundUploadedOnStage = backgroundUploadedOnStage;
exports.cameraChanged = cameraChanged;
exports.cameraToggled = cameraToggled;
exports.chatMessageSent = chatMessageSent;
exports.contentUploaded = contentUploaded;
exports["default"] = void 0;
exports.endStudioAttendeeBackgroundFilterChangeLatency = endStudioAttendeeBackgroundFilterChangeLatency;
exports.endStudioAttendeeUploadedUserBackground = endStudioAttendeeUploadedUserBackground;
exports.endStudioBackgroundUploadedOnStage = endStudioBackgroundUploadedOnStage;
exports.endStudioCameraToggled = endStudioCameraToggled;
exports.endStudioFileUpload = endStudioFileUpload;
exports.endStudioHostAddedMediaToStage = endStudioHostAddedMediaToStage;
exports.endStudioHostChangesStageLayout = endStudioHostChangesStageLayout;
exports.endStudioHostTogglesSpeakerCameraFromSourceTile = endStudioHostTogglesSpeakerCameraFromSourceTile;
exports.endStudioHostTogglesSpeakerMicFromSourceTile = endStudioHostTogglesSpeakerMicFromSourceTile;
exports.endStudioLoadChat = endStudioLoadChat;
exports.endStudioLoadReadinessChecker = endStudioLoadReadinessChecker;
exports.endStudioMeetingAsHost = endStudioMeetingAsHost;
exports.endStudioMicrophoneToggled = endStudioMicrophoneToggled;
exports.endStudioNameCardsToggled = endStudioNameCardsToggled;
exports.endStudioPageLoad = endStudioPageLoad;
exports.endStudioPresenterAddedToChimeMeeting = endStudioPresenterAddedToChimeMeeting;
exports.endStudioScreenShareStarted = endStudioScreenShareStarted;
exports.endStudioSourceProgramStatusUpdate = endStudioSourceProgramStatusUpdate;
exports.endStudioStartAllStreams = endStudioStartAllStreams;
exports.endStudioStreamStartLifecycle = endStudioStreamStartLifecycle;
exports.endStudioStreamStopLifecycle = endStudioStreamStopLifecycle;
exports.fileUpload = fileUpload;
exports.hostAddedScreenshareToStage = hostAddedScreenshareToStage;
exports.hostEnters = hostEnters;
exports.hostSpotlightsSourceFromSourceTile = hostSpotlightsSourceFromSourceTile;
exports.hostSpotlightsSourceFromStage = hostSpotlightsSourceFromStage;
exports.hostTogglesSpeakerCameraFromSourceTile = hostTogglesSpeakerCameraFromSourceTile;
exports.hostTogglesSpeakerMicFromSourceTile = hostTogglesSpeakerMicFromSourceTile;
exports.loadChat = loadChat;
exports.loadReadinessChecker = loadReadinessChecker;
exports.mediaPlaybackChanged = mediaPlaybackChanged;
exports.meetingAsHost = meetingAsHost;
exports.microphoneChanged = microphoneChanged;
exports.microphoneToggled = microphoneToggled;
exports.presenterAddedToChimeMeeting = presenterAddedToChimeMeeting;
exports.recordingStartedWorkflow = recordingStartedWorkflow;
exports.recordingStoppedWorkflow = recordingStoppedWorkflow;
exports.screenShareRequestSent = screenShareRequestSent;
exports.screenShareStarted = screenShareStarted;
exports.screenShareStopped = screenShareStopped;
exports.speakerEnters = speakerEnters;
exports.speakerViewChanged = speakerViewChanged;
exports.startAllStreams = startAllStreams;
exports.startStudioAttendeeBackgroundFilterChangeLatency = startStudioAttendeeBackgroundFilterChangeLatency;
exports.startStudioAttendeeUploadedUserBackground = startStudioAttendeeUploadedUserBackground;
exports.startStudioBackgroundUploadedOnStage = startStudioBackgroundUploadedOnStage;
exports.startStudioCameraToggled = startStudioCameraToggled;
exports.startStudioFileUpload = startStudioFileUpload;
exports.startStudioHostAddedMediaToStage = startStudioHostAddedMediaToStage;
exports.startStudioHostChangesStageLayout = startStudioHostChangesStageLayout;
exports.startStudioHostTogglesSpeakerCameraFromSourceTile = startStudioHostTogglesSpeakerCameraFromSourceTile;
exports.startStudioHostTogglesSpeakerMicFromSourceTile = startStudioHostTogglesSpeakerMicFromSourceTile;
exports.startStudioLoadChat = startStudioLoadChat;
exports.startStudioLoadReadinessChecker = startStudioLoadReadinessChecker;
exports.startStudioMeetingAsHost = startStudioMeetingAsHost;
exports.startStudioMicrophoneToggled = startStudioMicrophoneToggled;
exports.startStudioNameCardsToggled = startStudioNameCardsToggled;
exports.startStudioPageLoad = startStudioPageLoad;
exports.startStudioPresenterAddedToChimeMeeting = startStudioPresenterAddedToChimeMeeting;
exports.startStudioScreenShareStarted = startStudioScreenShareStarted;
exports.startStudioSourceProgramStatusUpdate = startStudioSourceProgramStatusUpdate;
exports.startStudioStartAllStreams = startStudioStartAllStreams;
exports.startStudioStreamStartLifecycle = startStudioStreamStartLifecycle;
exports.startStudioStreamStopLifecycle = startStudioStreamStopLifecycle;
exports.stockContentUsed = stockContentUsed;
exports.streamStartLifecycle = streamStartLifecycle;
exports.streamStartedWorkflow = streamStartedWorkflow;
exports.streamStopLifecycle = streamStopLifecycle;
exports.streamStoppedWorkflow = streamStoppedWorkflow;
exports.testAudioButtonClicked = testAudioButtonClicked;
exports.totalScreenShare = totalScreenShare;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Rudder = _interopRequireWildcard(require("../rudder-web"));
var _measurementTracker = require("./measurementTracker");
var _basePropertiesRegistry = require("./basePropertiesRegistry");
var _datadogLogger = _interopRequireDefault(require("../../logger/datadogLogger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * This client was automatically generated. ** Do Not Edit **
                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
var setRudderTyperOptions = Rudder.setRudderTyperOptions;
var withRudderTyperContext = Rudder.withRudderTyperContext;
// Track Calls
function backgroundUploaded(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio background uploaded', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'background uploaded'
    }), withRudderTyperContext(options), callback);
  }
}
function backgroundUploadedOnStage(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio background uploaded on stage', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'background uploaded on stage'
    }), withRudderTyperContext(options), callback);
  }
}
function cameraChanged(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio camera changed', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'camera changed'
    }), withRudderTyperContext(options), callback);
  }
}
function cameraToggled(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio camera toggled', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'camera toggled'
    }), withRudderTyperContext(options), callback);
  }
}
function chatMessageSent(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio chat message sent', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'chat message sent'
    }), withRudderTyperContext(options), callback);
  }
}
function contentUploaded(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio studio content uploaded', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'content uploaded'
    }), withRudderTyperContext(options), callback);
  }
}
function fileUpload(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio file upload', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'file upload'
    }), withRudderTyperContext(options), callback);
  }
}
function hostAddedScreenshareToStage(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio host added screenshare to stage', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host added screenshare to stage'
    }), withRudderTyperContext(options), callback);
  }
}
function hostEnters(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio host enters studio', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host enters'
    }), withRudderTyperContext(options), callback);
  }
}
function hostSpotlightsSourceFromSourceTile(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio host spotlights source from source tile', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host spotlights source from source tile'
    }), withRudderTyperContext(options), callback);
  }
}
function hostSpotlightsSourceFromStage(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio host spotlights source from stage', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host spotlights source from stage'
    }), withRudderTyperContext(options), callback);
  }
}
function recordingStartedWorkflow(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio recording started workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'recording started workflow'
    }), withRudderTyperContext(options), callback);
  }
}
function streamStartedWorkflow(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio stream started workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'stream started workflow'
    }), withRudderTyperContext(options), callback);
  }
}
function recordingStoppedWorkflow(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio recording stopped workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'recording stopped workflow'
    }), withRudderTyperContext(options), callback);
  }
}
function streamStoppedWorkflow(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio stream stopped workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'stream stopped workflow'
    }), withRudderTyperContext(options), callback);
  }
}
function hostTogglesSpeakerCameraFromSourceTile(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio host toggles speaker camera from source tile', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker camera from source tile'
    }), withRudderTyperContext(options), callback);
  }
}
function hostTogglesSpeakerMicFromSourceTile(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio host toggles speaker mic from source tile', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker mic from source tile'
    }), withRudderTyperContext(options), callback);
  }
}
function loadChat(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio load chat', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'load chat'
    }), withRudderTyperContext(options), callback);
  }
}
function loadReadinessChecker(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio load readiness checker', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'load readiness checker'
    }), withRudderTyperContext(options), callback);
  }
}
function mediaPlaybackChanged(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio media playback changed', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'media playback changed'
    }), withRudderTyperContext(options), callback);
  }
}
function meetingAsHost(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio meeting as host', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'meeting as host'
    }), withRudderTyperContext(options), callback);
  }
}
function microphoneChanged(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio microphone changed', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'microphone changed'
    }), withRudderTyperContext(options), callback);
  }
}
function microphoneToggled(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio microphone toggled', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'microphone toggled'
    }), withRudderTyperContext(options), callback);
  }
}
function presenterAddedToChimeMeeting(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio presenter added to chime meeting', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'presenter added to chime meeting'
    }), withRudderTyperContext(options), callback);
  }
}
function screenShareRequestSent(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio screen share request sent', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'screen share request sent'
    }), withRudderTyperContext(options), callback);
  }
}
function screenShareStarted(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio screen share started', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'screen share started'
    }), withRudderTyperContext(options), callback);
  }
}
function screenShareStopped(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio screen share stopped', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'screen share stopped'
    }), withRudderTyperContext(options), callback);
  }
}
function speakerEnters(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio speaker enters studio', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'speaker enters'
    }), withRudderTyperContext(options), callback);
  }
}
function speakerViewChanged(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio speaker view changed', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'speaker view changed'
    }), withRudderTyperContext(options), callback);
  }
}
function startAllStreams(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio start all streams', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'start all streams'
    }), withRudderTyperContext(options), callback);
  }
}
function stockContentUsed(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio stock content used', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'stock content used'
    }), withRudderTyperContext(options), callback);
  }
}
function streamStartLifecycle(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio stream start lifecycle', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'stream start lifecycle'
    }), withRudderTyperContext(options), callback);
  }
}
function streamStopLifecycle(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio stream stop lifecycle', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'stream stop lifecycle'
    }), withRudderTyperContext(options), callback);
  }
}
function testAudioButtonClicked(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio test audio button clicked', _objectSpread(_objectSpread({}, props), {}, {
      version: '',
      downstreamName: 'test audio button clicked'
    }), withRudderTyperContext(options), callback);
  }
}
function totalScreenShare(props, options, callback) {
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track('studio total screen share', _objectSpread(_objectSpread({}, props), {}, {
      version: '1-0-0',
      downstreamName: 'total screen share'
    }), withRudderTyperContext(options), callback);
  }
}

// Measure-type actions (auto-generated by enhance-web-analytics.mjs)

/**
 * Start measuring: this action measures the time taken in navigations to any page, as measured from the browser
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio page_load
 * downstreamName: page_load
 * owner         : and1
 * phase         : analytics
 * release       : v1.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the user either changes routes or reloads the page and ends when the page indicates it has finished loading the main content
 * destinations  :
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioPageLoad(props) {
  var actionId = 'studio page_load';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in navigations to any page, as measured from the browser
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioPageLoad(props, callback) {
  var actionId = 'studio page_load';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = '';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'page_load'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'page_load'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in uploading a background image on the stage
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio background uploaded on stage
 * downstreamName: background uploaded on stage
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the user clicks the save button in the upload background modal and ends when the image uploads on the stage
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioBackgroundUploadedOnStage(props) {
  var actionId = 'studio background uploaded on stage';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in uploading a background image on the stage
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioBackgroundUploadedOnStage(props, callback) {
  var actionId = 'studio background uploaded on stage';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'background uploaded on stage'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'background uploaded on stage'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: This action measures the time taken in toggling an attendee's camera on or off to understand responsiveness and user behavior.
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio camera toggled
 * downstreamName: camera toggled
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the speaker clicks the Start/Stop video button to toggle their camera, and ends when the camera state change (on/off) is completed and reflected in the UI
 * destinations  :datadog,Mixpanel,Snowflake
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioCameraToggled(props) {
  var actionId = 'studio camera toggled';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: This action measures the time taken in toggling an attendee's camera on or off to understand responsiveness and user behavior.
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioCameraToggled(props, callback) {
  var actionId = 'studio camera toggled';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'camera toggled'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'camera toggled'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in uploading a file
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio file upload
 * downstreamName: file upload
 * owner         : incognito
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the user clicks the save button in the upload file modal and ends when the file is uploaded
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioFileUpload(props) {
  var actionId = 'studio file upload';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in uploading a file
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioFileUpload(props, callback) {
  var actionId = 'studio file upload';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'file upload'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'file upload'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in toggling a speaker camera from the source tile in order to better understand how often cameras are being toggled
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio host toggles speaker camera from source tile
 * downstreamName: host toggles speaker camera from source tile
 * owner         : quickfixjedis
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the host hovers over a source on the source tile and clicks the camera icon, and ends when the camera state change is completed
 * destinations  :Datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioHostTogglesSpeakerCameraFromSourceTile(props) {
  var actionId = 'studio host toggles speaker camera from source tile';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in toggling a speaker camera from the source tile in order to better understand how often cameras are being toggled
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioHostTogglesSpeakerCameraFromSourceTile(props, callback) {
  var actionId = 'studio host toggles speaker camera from source tile';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'Datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'host toggles speaker camera from source tile'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker camera from source tile'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in toggling speaker source mic from the source tile in order to better understand how often mics are being toggled
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio host toggles speaker mic from source tile
 * downstreamName: host toggles speaker mic from source tile
 * owner         : quickfixjedis
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the host hovers over a source on the source tile and toggles mic, and ends when the mic state change is completed
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioHostTogglesSpeakerMicFromSourceTile(props) {
  var actionId = 'studio host toggles speaker mic from source tile';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in toggling speaker source mic from the source tile in order to better understand how often mics are being toggled
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioHostTogglesSpeakerMicFromSourceTile(props, callback) {
  var actionId = 'studio host toggles speaker mic from source tile';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'host toggles speaker mic from source tile'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'host toggles speaker mic from source tile'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in loading studio chat
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio load chat
 * downstreamName: load chat
 * owner         : vikings
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when chat opens and ends when the channel is created and attendee joins
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioLoadChat(props) {
  var actionId = 'studio load chat';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in loading studio chat
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioLoadChat(props, callback) {
  var actionId = 'studio load chat';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'load chat'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'load chat'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in loading the readiness checker, creation of sandbox meeting and adding of attendee to the meeting
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio load readiness checker
 * downstreamName: load readiness checker
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when readiness checker opens and ends when sandbox meeting is created and attendee is added to the meeting
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioLoadReadinessChecker(props) {
  var actionId = 'studio load readiness checker';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in loading the readiness checker, creation of sandbox meeting and adding of attendee to the meeting
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioLoadReadinessChecker(props, callback) {
  var actionId = 'studio load readiness checker';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'load readiness checker'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'load readiness checker'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in director lite application to get loaded till the chime meeting creation
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio meeting as host
 * downstreamName: meeting as host
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the application started for chime meeting creation and ends when the chime meeting got created
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioMeetingAsHost(props) {
  var actionId = 'studio meeting as host';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in director lite application to get loaded till the chime meeting creation
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioMeetingAsHost(props, callback) {
  var actionId = 'studio meeting as host';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'meeting as host'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'meeting as host'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: This action measures the time taken in toggling the attendee’s microphone on or off to understand responsiveness and user behavior.
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio microphone toggled
 * downstreamName: microphone toggled
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the speaker clicks the mute/unmute button to toggle their microphone, and ends when the microphone state change (ON/OFF) is completed and reflected in the UI
 * destinations  :datadog,Mixpanel,Snowflake
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioMicrophoneToggled(props) {
  var actionId = 'studio microphone toggled';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: This action measures the time taken in toggling the attendee’s microphone on or off to understand responsiveness and user behavior.
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioMicrophoneToggled(props, callback) {
  var actionId = 'studio microphone toggled';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'microphone toggled'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'microphone toggled'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in presenter getting added to a chime meeting.
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio presenter added to chime meeting
 * downstreamName: presenter added to chime meeting
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when host accepts the knock request and ends when presenter is added to chime meeting successfully
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioPresenterAddedToChimeMeeting(props) {
  var actionId = 'studio presenter added to chime meeting';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in presenter getting added to a chime meeting.
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioPresenterAddedToChimeMeeting(props, callback) {
  var actionId = 'studio presenter added to chime meeting';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'presenter added to chime meeting'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'presenter added to chime meeting'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in starting screen share
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio screen share started
 * downstreamName: screen share started
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the screen share request is submitted to SDK, and ends when the screen share request has completed
 * destinations  :datadog,Mixpanel,Snowflake
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioScreenShareStarted(props) {
  var actionId = 'studio screen share started';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in starting screen share
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioScreenShareStarted(props, callback) {
  var actionId = 'studio screen share started';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'screen share started'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'screen share started'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in the start all stream operation
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio start all streams
 * downstreamName: start all streams
 * owner         : incognito
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the host clicks on the startAll stream button and ends when all the streams have either started or failed
 * destinations  :datadog,Mixpanel
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioStartAllStreams(props) {
  var actionId = 'studio start all streams';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in the start all stream operation
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioStartAllStreams(props, callback) {
  var actionId = 'studio start all streams';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'start all streams'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'start all streams'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in starting the stream
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio stream start lifecycle
 * downstreamName: stream start lifecycle
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the user click on the start/startAll stream button and ends when the streaming is started or failed in starting
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioStreamStartLifecycle(props) {
  var actionId = 'studio stream start lifecycle';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in starting the stream
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioStreamStartLifecycle(props, callback) {
  var actionId = 'studio stream start lifecycle';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'stream start lifecycle'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'stream start lifecycle'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in stopping the stream
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio stream stop lifecycle
 * downstreamName: stream stop lifecycle
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the user click on the stop/stopAll stream button and ends when the streaming is stopped or failed in stopping
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioStreamStopLifecycle(props) {
  var actionId = 'studio stream stop lifecycle';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in stopping the stream
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioStreamStopLifecycle(props, callback) {
  var actionId = 'studio stream stop lifecycle';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'stream stop lifecycle'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'stream stop lifecycle'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in changing the background filter feature for attendees
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio attendee background filter change latency
 * downstreamName: attendee background filter change latency
 * owner         : vikings
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the attendee triggers the background filter feature and ends when it is successfully added
 * destinations  :datadog,Mixpanel
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioAttendeeBackgroundFilterChangeLatency(props) {
  var actionId = 'studio attendee background filter change latency';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in changing the background filter feature for attendees
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioAttendeeBackgroundFilterChangeLatency(props, callback) {
  var actionId = 'studio attendee background filter change latency';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'attendee background filter change latency'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'attendee background filter change latency'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in uploading a custom user background for attendees
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio attendee uploaded user background
 * downstreamName: attendee uploaded user background
 * owner         : vikings
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the attendee uploads a custom user background and ends when it is successfully uploaded
 * destinations  :datadog,Mixpanel
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioAttendeeUploadedUserBackground(props) {
  var actionId = 'studio attendee uploaded user background';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in uploading a custom user background for attendees
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioAttendeeUploadedUserBackground(props, callback) {
  var actionId = 'studio attendee uploaded user background';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'attendee uploaded user background'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'attendee uploaded user background'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in adding media to stage by user in order to better understand the quantity and how often this is occurring throughout a webinar
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio host added media to stage
 * downstreamName: host added media to stage
 * owner         : vikings
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the host hovers over a media source and clicks the show button and ends when the media is fully rendered on the stage
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioHostAddedMediaToStage(props) {
  var actionId = 'studio host added media to stage';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in adding media to stage by user in order to better understand the quantity and how often this is occurring throughout a webinar
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioHostAddedMediaToStage(props, callback) {
  var actionId = 'studio host added media to stage';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'host added media to stage'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'host added media to stage'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in stage layout change to any of the available layouts in order to better understand which layouts are being used
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio host changes stage layout
 * downstreamName: host changes stage layout
 * owner         : quickfixjedis
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the host clicks any of the layout on the layout bar and ends when the layout is fully rendered on the stage
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioHostChangesStageLayout(props) {
  var actionId = 'studio host changes stage layout';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in stage layout change to any of the available layouts in order to better understand which layouts are being used
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioHostChangesStageLayout(props, callback) {
  var actionId = 'studio host changes stage layout';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'host changes stage layout'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'host changes stage layout'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in toggle name cards in order to better understand if and when name cards are used
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio name cards toggled
 * downstreamName: name cards toggled
 * owner         : quickfixjedis
 * phase         : activation
 * release       : v2.0
 * version       :1-0-0
 * type          : measure
 * trigger       : the measurement starts when the user toggles the name card and ends when the name cards are fully rendered on the stage
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioNameCardsToggled(props) {
  var actionId = 'studio name cards toggled';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in toggle name cards in order to better understand if and when name cards are used
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioNameCardsToggled(props, callback) {
  var actionId = 'studio name cards toggled';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'name cards toggled'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'name cards toggled'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}

/**
 * Start measuring: this action measures the time taken in adding/removing the source from program
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * name          : studio source program status update
 * downstreamName: source program status update
 * owner         : qwerty
 * phase         : activation
 * release       : v2.0
 * version       :
 * type          : measure
 * trigger       : the measurement starts when the host hovers over a source and clicks the show/hide button and ends when source is visible/removed from program
 * destinations  :datadog,Mixpanel,Snowflake,Intercom
 * ------------------------------------------------------
 *
 * @param {Object} [props] - The analytics properties to store for this measurement
 */
function startStudioSourceProgramStatusUpdate(props) {
  var actionId = 'studio source program status update';
  (0, _measurementTracker.startMeasurement)(actionId, props);
}

/**
 * End measuring: this action measures the time taken in adding/removing the source from program
 *
 * @param {Object} [props] - Additional analytics properties to merge
 * @param {Function} [callback] - Callback function
 */
function endStudioSourceProgramStatusUpdate(props, callback) {
  var actionId = 'studio source program status update';
  var combinedProps = (0, _measurementTracker.endMeasurement)(actionId, props);
  if (!combinedProps) {
    return; // No measurement was started
  }

  var destinationsStr = 'datadog,Mixpanel,Snowflake,Intercom';
  var destinations = destinationsStr.split(',').map(function (dest) {
    return dest.trim();
  }).filter(function (dest) {
    return dest.length > 0;
  }).map(function (dest) {
    return dest === 'Datadog' ? 'datadog' : dest;
  });
  var baseProps = (0, _basePropertiesRegistry.getBaseProperties)();

  // Send to Datadog directly (like pageAction.js does)
  (0, _datadogLogger["default"])(destinations, actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
    version: '1-0-0',
    downstreamName: 'source program status update'
  }));
  var a = Rudder.getAnalyticsInstance();
  if (a) {
    a.track(actionId, _objectSpread(_objectSpread(_objectSpread({}, combinedProps), baseProps), {}, {
      version: '1-0-0',
      downstreamName: 'source program status update'
    }), withRudderTyperContext(_objectSpread({}, destinations.length > 0 && {
      integrations: destinations.reduce(function (acc, dest) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, dest, true));
      }, {})
    })), callback);
  }
}
var clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions: setRudderTyperOptions,
  /**
   * this action tracks the users who upload a custom background in order to understand how many users are creating custom backgrounds
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepZgdlXMWD3ORK2EJCYaAKd
   * name          : studio background uploaded
   * downstreamName: background uploaded
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user uploads a background image locally and clicks the save button in the upload background modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {BackgroundUploaded} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  backgroundUploaded: backgroundUploaded,
  /**
   * this action measures the time taken in uploading a background image on the stage
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeo3UKYzw6h6uQbxEOi7hPsD
   * name          : studio background uploaded on stage
   * downstreamName: background uploaded on stage
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user clicks the save button in the upload background modal and ends when the image uploads on the stage
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {BackgroundUploadedOnStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  backgroundUploadedOnStage: backgroundUploadedOnStage,
  /**
   * This action tracks the users who change their camera in order to use different camera source.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio camera changed
   * downstreamName: camera changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user toggles their Camera
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {CameraChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  cameraChanged: cameraChanged,
  /**
   * This action measures the time taken in toggling an attendee's camera on or off to understand responsiveness and user behavior.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio camera toggled
   * downstreamName: camera toggled
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the speaker clicks the Start/Stop video button to toggle their camera, and ends when the camera state change (on/off) is completed and reflected in the UI
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {CameraToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  cameraToggled: cameraToggled,
  /**
   * this action tracks the users who send messages using embedded chat in order to better understand chat usage
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio chat message sent
   * downstreamName: chat message sent
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when a user sends a message in embedded chat
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ChatMessageSent} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  chatMessageSent: chatMessageSent,
  /**
   * this action tracks the users who upload content in order to determine content is being successfully uploaded
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeldCvGmrRAHwROauiH92e54
   * name          : studio studio content uploaded
   * downstreamName: content uploaded
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user uploads content and clicks the upload button in the add media modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ContentUploaded} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  contentUploaded: contentUploaded,
  /**
   * this action measures the time taken in uploading a file
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio file upload
   * downstreamName: file upload
   * owner         : incognito
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user clicks the save button in the upload file modal and ends when the file is uploaded
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {FileUpload} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  fileUpload: fileUpload,
  /**
   * this action tracks the users who are adding screenshares to stage in order to better understand the quantity and how often this is occurring throughout a webinar
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeoDxFrXC8qonY097NqfJGmz
   * name          : studio host added screenshare to stage
   * downstreamName: host added screenshare to stage
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a screenshare source and clicks the "show" button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostAddedScreenshareToStage} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostAddedScreenshareToStage: hostAddedScreenshareToStage,
  /**
   * this action tracks the users who enters a studio session in order to determine how many users are joining as hosts
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMekb4RhLhaEGChHWof1UI9mO
   * name          : studio host enters studio
   * downstreamName: host enters
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host clicks the enter the studio button on the join modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostEnters} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostEnters: hostEnters,
  /**
   * this action tracks the users who spotlight a source from the source tile in order to better understand which spotlight option is being used more or less
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelWz09Eh8abbXrCYhxxxsXq
   * name          : studio host spotlights source from source tile
   * downstreamName: host spotlights source from source tile
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on the source tile and clicks the spotlight button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSpotlightsSourceFromSourceTile} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostSpotlightsSourceFromSourceTile: hostSpotlightsSourceFromSourceTile,
  /**
   * this action tracks the users who spotlight a source from stage in order to better understand which spotlight option is being used more or less
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepTguwPrOo84AM6tTSsCqQv
   * name          : studio host spotlights source from stage
   * downstreamName: host spotlights source from stage
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on stage and clicks the spotlight button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSpotlightsSourceFromStage} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostSpotlightsSourceFromStage: hostSpotlightsSourceFromStage,
  /**
   * this action tracks the users who started the recording(s) in order to better understand the life cycle of a recording
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio recording started workflow
   * downstreamName: recording started workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the start/startAll record button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {RecordingStartedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  recordingStartedWorkflow: recordingStartedWorkflow,
  /**
   * this action tracks the users who started the stream(s) in order to better understand the life cycle of a stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream started workflow
   * downstreamName: stream started workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the start/startAll stream button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStartedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStartedWorkflow: streamStartedWorkflow,
  /**
   * this action tracks the users who stopped the recording(s) in order to better understand the life cycle of a recording
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio recording stopped workflow
   * downstreamName: recording stopped workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the start/startAll record button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {RecordingStoppedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  recordingStoppedWorkflow: recordingStoppedWorkflow,
  /**
   * this action tracks the users who stopped the stream(s) in order to better understand the life cycle of a stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream stopped workflow
   * downstreamName: stream stopped workflow
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the stop/stopAll stream button
   * destinations  : Intercom,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStoppedWorkflow} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStoppedWorkflow: streamStoppedWorkflow,
  /**
   * this action measures the time taken in toggling a speaker camera from the source tile in order to better understand how often cameras are being toggled
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelyGkpwBBbCk3oHu538sZ4C
   * name          : studio host toggles speaker camera from source tile
   * downstreamName: host toggles speaker camera from source tile
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host hovers over a source on the source tile and clicks the camera icon, and ends when the camera state change is completed
   * destinations  : Datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostTogglesSpeakerCameraFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostTogglesSpeakerCameraFromSourceTile: hostTogglesSpeakerCameraFromSourceTile,
  /**
   * this action measures the time taken in toggling speaker source mic from the source tile in order to better understand how often mics are being toggled
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeq6sM9IinTASO0d8uYFaTa9
   * name          : studio host toggles speaker mic from source tile
   * downstreamName: host toggles speaker mic from source tile
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host hovers over a source on the source tile and toggles mic, and ends when the mic state change is completed
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostTogglesSpeakerMicFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostTogglesSpeakerMicFromSourceTile: hostTogglesSpeakerMicFromSourceTile,
  /**
   * this action measures the time taken in loading studio chat
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio load chat
   * downstreamName: load chat
   * owner         : vikings
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when chat opens and ends when the channel is created and attendee joins
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {LoadChat} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  loadChat: loadChat,
  /**
   * this action measures the time taken in loading the readiness checker, creation of sandbox meeting and adding of attendee to the meeting
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio load readiness checker
   * downstreamName: load readiness checker
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when readiness checker opens and ends when sandbox meeting is created and attendee is added to the meeting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {LoadReadinessChecker} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  loadReadinessChecker: loadReadinessChecker,
  /**
   * this action tracks the users who clicked on the media controls on stage in order to know what type of media action was performed by the host
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio media playback changed
   * downstreamName: media playback changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host uses the media controls on stage
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MediaPlaybackChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  mediaPlaybackChanged: mediaPlaybackChanged,
  /**
   * this action measures the time taken in director lite application to get loaded till the chime meeting creation
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeny4usepwA0m0rUkS7YjjNP
   * name          : studio meeting as host
   * downstreamName: meeting as host
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the application started for chime meeting creation and ends when the chime meeting got created
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MeetingAsHost} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  meetingAsHost: meetingAsHost,
  /**
   * This action tracks the users who change their microphone in order to use different audio source.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio microphone changed
   * downstreamName: microphone changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user toggles their microphone
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MicrophoneChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  microphoneChanged: microphoneChanged,
  /**
   * This action measures the time taken in toggling the attendee’s microphone on or off to understand responsiveness and user behavior.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio microphone toggled
   * downstreamName: microphone toggled
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the speaker clicks the mute/unmute button to toggle their microphone, and ends when the microphone state change (ON/OFF) is completed and reflected in the UI
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MicrophoneToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  microphoneToggled: microphoneToggled,
  /**
   * this action measures the time taken in presenter getting added to a chime meeting.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMekRHdCvCEm0GKbgq1JDMFpR
   * name          : studio presenter added to chime meeting
   * downstreamName: presenter added to chime meeting
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when host accepts the knock request and ends when presenter is added to chime meeting successfully
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {PresenterAddedToChimeMeeting} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  presenterAddedToChimeMeeting: presenterAddedToChimeMeeting,
  /**
   * this action tracks the users who send the request in order to share their screen.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio screen share request sent
   * downstreamName: screen share request sent
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the speaker sends the request to share their screen by clicking on the share screen button on the presenter studio page
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ScreenShareRequestSent} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  screenShareRequestSent: screenShareRequestSent,
  /**
   * this action measures the time taken in starting screen share
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio screen share started
   * downstreamName: screen share started
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the screen share request is submitted to SDK, and ends when the screen share request has completed
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ScreenShareStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  screenShareStarted: screenShareStarted,
  /**
   * this action tracks the users who stopped sharing their screen in order to know when user stops sharing their screen
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio screen share stopped
   * downstreamName: screen share stopped
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user stops sharing their screen
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ScreenShareStopped} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  screenShareStopped: screenShareStopped,
  /**
   * this action tracks the users who enter the studio after knock is approved in order to understand speaker experience joining the studio
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMek6vGle76DdjtYLbpUWbh0D
   * name          : studio speaker enters studio
   * downstreamName: speaker enters
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the enter the studio button on the final join modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {SpeakerEnters} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  speakerEnters: speakerEnters,
  /**
   * This action tracks the users who change their viewing mode in order to view the speaker studio page in either minimize or expand mode.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio speaker view changed
   * downstreamName: speaker view changed
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the speaker either clicks on Expand or Minimize button in the speaker studio page
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {SpeakerViewChanged} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  speakerViewChanged: speakerViewChanged,
  /**
   * this action measures the time taken in the start all stream operation
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio start all streams
   * downstreamName: start all streams
   * owner         : incognito
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host clicks on the startAll stream button and ends when all the streams have either started or failed
   * destinations  : datadog,Mixpanel
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StartAllStreams} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  startAllStreams: startAllStreams,
  /**
   * this action tracks the users who use our stock content for their webinar in order to see how often they are used
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMejtXyCXQZMPvJsQLGazMfSS
   * name          : studio stock content used
   * downstreamName: stock content used
   * owner         : quickfixjedis
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user selects stock content and clicks save button
   * destinations  : Datadog,Mixpanel,Intercom,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StockContentUsed} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  stockContentUsed: stockContentUsed,
  /**
   * this action measures the time taken in starting the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream start lifecycle
   * downstreamName: stream start lifecycle
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the start/startAll stream button and ends when the streaming is started or failed in starting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStartLifecycle} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStartLifecycle: streamStartLifecycle,
  /**
   * this action measures the time taken in stopping the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream stop lifecycle
   * downstreamName: stream stop lifecycle
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the stop/stopAll stream button and ends when the streaming is stopped or failed in stopping
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStopLifecycle} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStopLifecycle: streamStopLifecycle,
  /**
   * This action tracks the users who clicks on test audio button in order to test their audio setup
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio test audio button clicked
   * downstreamName: test audio button clicked
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       :
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user tests their audio by clicking the test audio button
   * destinations  : datadog,Mixpanel,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {TestAudioButtonClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  testAudioButtonClicked: testAudioButtonClicked,
  /**
   * this action tracks the users who as presenter share screen in order to determine screen share total is working fine
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeo6kDKYM3TAQr5HBGjykkKw
   * name          : studio total screen share
   * downstreamName: total screen share
   * owner         : qwerty
   * phase         : activation
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user shares the screen and see the total count of share screen
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {TotalScreenShare} props - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  totalScreenShare: totalScreenShare,
  startStudioPageLoad: startStudioPageLoad,
  endStudioPageLoad: endStudioPageLoad,
  startStudioBackgroundUploadedOnStage: startStudioBackgroundUploadedOnStage,
  endStudioBackgroundUploadedOnStage: endStudioBackgroundUploadedOnStage,
  startStudioCameraToggled: startStudioCameraToggled,
  endStudioCameraToggled: endStudioCameraToggled,
  startStudioFileUpload: startStudioFileUpload,
  endStudioFileUpload: endStudioFileUpload,
  startStudioHostTogglesSpeakerCameraFromSourceTile: startStudioHostTogglesSpeakerCameraFromSourceTile,
  endStudioHostTogglesSpeakerCameraFromSourceTile: endStudioHostTogglesSpeakerCameraFromSourceTile,
  startStudioHostTogglesSpeakerMicFromSourceTile: startStudioHostTogglesSpeakerMicFromSourceTile,
  endStudioHostTogglesSpeakerMicFromSourceTile: endStudioHostTogglesSpeakerMicFromSourceTile,
  startStudioLoadChat: startStudioLoadChat,
  endStudioLoadChat: endStudioLoadChat,
  startStudioLoadReadinessChecker: startStudioLoadReadinessChecker,
  endStudioLoadReadinessChecker: endStudioLoadReadinessChecker,
  startStudioMeetingAsHost: startStudioMeetingAsHost,
  endStudioMeetingAsHost: endStudioMeetingAsHost,
  startStudioMicrophoneToggled: startStudioMicrophoneToggled,
  endStudioMicrophoneToggled: endStudioMicrophoneToggled,
  startStudioPresenterAddedToChimeMeeting: startStudioPresenterAddedToChimeMeeting,
  endStudioPresenterAddedToChimeMeeting: endStudioPresenterAddedToChimeMeeting,
  startStudioScreenShareStarted: startStudioScreenShareStarted,
  endStudioScreenShareStarted: endStudioScreenShareStarted,
  startStudioStartAllStreams: startStudioStartAllStreams,
  endStudioStartAllStreams: endStudioStartAllStreams,
  startStudioStreamStartLifecycle: startStudioStreamStartLifecycle,
  endStudioStreamStartLifecycle: endStudioStreamStartLifecycle,
  startStudioStreamStopLifecycle: startStudioStreamStopLifecycle,
  endStudioStreamStopLifecycle: endStudioStreamStopLifecycle,
  startStudioAttendeeBackgroundFilterChangeLatency: startStudioAttendeeBackgroundFilterChangeLatency,
  endStudioAttendeeBackgroundFilterChangeLatency: endStudioAttendeeBackgroundFilterChangeLatency,
  startStudioAttendeeUploadedUserBackground: startStudioAttendeeUploadedUserBackground,
  endStudioAttendeeUploadedUserBackground: endStudioAttendeeUploadedUserBackground,
  startStudioHostAddedMediaToStage: startStudioHostAddedMediaToStage,
  endStudioHostAddedMediaToStage: endStudioHostAddedMediaToStage,
  startStudioHostChangesStageLayout: startStudioHostChangesStageLayout,
  endStudioHostChangesStageLayout: endStudioHostChangesStageLayout,
  startStudioNameCardsToggled: startStudioNameCardsToggled,
  endStudioNameCardsToggled: endStudioNameCardsToggled,
  startStudioSourceProgramStatusUpdate: startStudioSourceProgramStatusUpdate,
  endStudioSourceProgramStatusUpdate: endStudioSourceProgramStatusUpdate
};
var commonAnalyticsClient = new Proxy(clientAPI, {
  get: function get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return function () {
      console.warn("\u26A0\uFE0F  You made an analytics call (".concat(String(method), ") that can't be found. Either:\n    a) Re-generate your ruddertyper client: `npx rudder-typer`\n    b) Add it to your Tracking Plan: https://app.rudderstack.com/trackingPlans/tp_2VcMepdGsODn30mzqfuBdd60Wrw"));
      var a = Rudder.getAnalyticsInstance();
      if (a) {
        a.track('Unknown Analytics Call Fired', {
          method: method
        }, withRudderTyperContext());
      }
    };
  }
});
var _default = exports["default"] = commonAnalyticsClient;